import { useState, useRef } from "react";
import Loader from "../../../components/loader";
import UiButton from "../../../components/button";
import TextInput from "../../../components/textinput/TextInput";
import { Row, Col } from "react-bootstrap";
import UiTable from "../../../components/table/Table";
import {
  useRevenueShareList,
  useNetworkOptions,
  useSupportedTokens,
} from "../../../context/contractDataLoaderService";
import VerticallyModal from "../../../components/modal/VerticallyModal";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { Distribution, contractAddress } from "@verified-network/verified-sdk";
import {
  SuccessToast,
  FailureToast,
  ToastOptions,
  networks,
} from "../../../utils/constants";
import { toast } from "react-toastify";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../../utils/helpers/networks";
import { providers } from "ethers";
import { useGlobal } from "../../../context/globalContext";
import { getAllVerifiedCashBalances } from "../../../utils/helpers";

function RevenueDetails(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;
  let { data } = useSupportedTokens();
  let { data: revenueList } = useRevenueShareList();

  const modalContent = useRef(null);
  const { data: networkOptions } = useNetworkOptions();
  const [filterOptionSelected] = useState(null);
  const [changeContent, setChangeContent] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedCurrencyToken, setSelectedCurrencyToken] = useState(null);
  const [tokenName, setTokenName] = useState("Select Token");

  const [shareHolderAdress, setHolderAddress] = useState(null);
  const [type, setType] = useState("Business");
  const [loading, setLoading] = useState(false);
  const filterOption = [
    { name: "Share payment and loan fees", id: 1 },
    { name: "Share issuing and trading fees", id: 2 },
    { name: "Add revenue share party", id: 3 },
  ];
  const shareholderTypes = ["Business", "Operator"];
  let distributionContract;

  if (provider && provider.getSigner && chainId && address) {
    distributionContract = new Distribution(
      signer,
      contractAddress[chainId].Distribution,
    );
  }
  let headers = [
    { label: "Name", val: "accountHolder" },
    { label: "Type", val: "shareholderType" },
    { label: "Token Name", val: "tokenName" },
    { label: "Date(UTC)", val: "date" },
    { label: "Amount (VITTA)", val: "tokenAmount" },
  ];
  const shareRevenue = async (id) => {
    if (id === 1) {
      setLoading(true);
      try {
        const tx = await distributionContract.shareFee();
        if (tx.code === "ACTION_REJECTED") {
          toast.error("Transaction rejected by user!", ToastOptions);
        } else {
          const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${tx.response.hash}`;
          toast.success(SuccessToast(transactionLink), ToastOptions);
        }
        setLoading(false);
      } catch (err) {
        let error = { err };
        console.log(error);
        const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${error.err.transactionHash}`;
        setLoading(false);
        toast.error(FailureToast(transactionLink), ToastOptions);
      }
    } else if (id === 2) {
      setLoading(true);
      try {
        const tx = await distributionContract.shareCollection();
        if (tx.code === "ACTION_REJECTED") {
          toast.error("Transaction rejected by user!", ToastOptions);
        } else {
          const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${tx.response.hash}`;
          toast.success(SuccessToast(transactionLink), ToastOptions);
        }
        setLoading(false);
      } catch (err) {
        let error = { err };
        console.log(error);
        const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${error.err.transactionHash}`;
        setLoading(false);
        toast.error(FailureToast(transactionLink), ToastOptions);
      }
    } else if (id === 3) {
      setShowModal(true);
    }
  };
  const addRevenueHolder = async () => {
    setLoading(true);
    try {
      let paymentToken;

      if (
        verifiedWalletDetails &&
        Object?.keys(verifiedWalletDetails)?.length > 0
      ) {
        const cashTokens = await getAllVerifiedCashBalances(
          chainId,
          web3,
          account,
        );

        if (!cashTokens || cashTokens?.length === 0) {
          setLoading(false);
          toast.error(
            "No valid Cash Token on this network. Change network and try again.",
            ToastOptions,
          );

          return;
        }
        paymentToken = cashTokens[0];
        const txQuote = await distributionContract._getMeeQuote(
          cashTokens[0]?.address,
          "addRevenueShareholder",
          [type, shareHolderAdress, selectedCurrencyToken.tokenAddress],
        );

        if (
          Number(cashTokens[0]?.balance) === 0 ||
          Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
        ) {
          setLoading(false);
          toast.error(
            `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
            ToastOptions,
          );

          return;
        }
      }

      await distributionContract
        .addRevenueShareholder(
          type,
          shareHolderAdress,
          selectedCurrencyToken.tokenAddress,
          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
              }
            : {},
        )
        .then((res) => {
          setLoading(false);
          if (res?.status === 0) {
            const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res?.response?.hash}`;
            toast.success(SuccessToast(transactionLink), ToastOptions);
            setChangeContent(true);
            modalContent.current.innerHTML = "";
          } else {
            toast.error("Transaction Failed", ToastOptions);
          }
        });
    } catch (err) {
      let error = { err };
      console.log(error);
      const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${error.err?.transactionHash}`;
      setLoading(false);
      toast.error(FailureToast(transactionLink), ToastOptions);
    }
  };
  return (
    <>
      {loading ? <Loader /> : null}
      <section className="d-flex flex-column align-items-start px-0 py-4">
        <div className="mb-3 d-flex justify-content-between w-100 align-items-center">
          <div className="w-50">
            <h3 className="text-left">Share Revenue</h3>
          </div>
          <div className="w-50 text-right">
            <DropdownButton
              id="dropdown-basic-button"
              title={
                filterOptionSelected
                  ? filterOptionSelected.name
                  : "Select option"
              }
            >
              {filterOption?.map((option, index) => (
                <Dropdown.Item
                  key={index}
                  onClick={(e) => shareRevenue(option.id)}
                >
                  {option.name}
                </Dropdown.Item>
              ))}
            </DropdownButton>
          </div>
        </div>
        <div className="pools-table width-100">
          <UiTable
            thead={headers}
            tbodyData={revenueList ?? []}
            hover
            bordered={false}
            signer={signer}
            ower={account}
            chainId={chainId}
            networkOptions={networkOptions}
            contract={distributionContract}
            verifiedWalletDetails={verifiedWalletDetails}
            web3={web3}
          />
        </div>
      </section>
      <VerticallyModal
        key="connectProvider"
        showModal={showModal}
        modalOnHide={() => {
          setShowModal(false);
        }}
        modalSize={"lg"}
        modalHeading={
          <h2>
            <b>Add Shareholder</b>
          </h2>
        }
        withFooter={false}
      >
        {changeContent && (
          <UiButton
            onClick={() => {
              setShowModal(false);
              setChangeContent(false);
            }}
            buttonVariant="primary"
            buttonClass="SignUpButton flex-1 ml-0"
            buttonText="Click to close this form&nbsp;&rarr;"
            type="submit"
          />
        )}
        <div className="d-grid gap-2" ref={modalContent}>
          <Row className="ml-1 align-items-center">
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 3, offset: 2 }} className="text-left">
                <b>Token address</b>
              </Col>
              <Col className="pl-0" xs={5}>
                <DropdownButton id="dropdown-basic-button" title={tokenName}>
                  {data?.map((token, index) => (
                    <Dropdown.Item
                      key={index}
                      onClick={(e) => {
                        setTokenName(token?.tokenName);
                        setSelectedCurrencyToken(token);
                      }}
                    >
                      {token?.tokenName}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </Col>
            </Row>
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 3, offset: 2 }} className="text-left">
                <b>Shareholder</b>
              </Col>
              <Col className="pl-0" xs={5}>
                <TextInput
                  placeholder="Address"
                  fieldType="text"
                  required
                  onChange={(e) => setHolderAddress(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 3, offset: 2 }} className="text-left">
                <b>Shareholder Type</b>
              </Col>
              <Col className="pl-0" xs={5}>
                <DropdownButton id="dropdown-basic-button" title={type}>
                  {shareholderTypes?.map((type, index) => (
                    <Dropdown.Item
                      key={index}
                      onClick={(e) => {
                        setType(type);
                      }}
                    >
                      {type}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </Col>
            </Row>

            <Row className="mx-0 my-2 pl-0 width-100 align-items-center">
              <Col className="pl-0" xs={4} />
              <Col className="pl-0" xs={4}>
                <UiButton
                  onClick={() => {
                    if (web3 && signer && account && chainId) {
                      addRevenueHolder();
                    }
                  }}
                  buttonVariant="primary"
                  buttonClass="SignUpButton flex-1 ml-0"
                  buttonText="Add"
                  type="submit"
                />
                <Col className="pl-0" xs={4} />
              </Col>
            </Row>
          </Row>
        </div>
      </VerticallyModal>
    </>
  );
}

export default function RevenueShare(props) {
  return <RevenueDetails {...props} />;
}
